


export class EligibilitySummaryRequest {
  constructor(

        public referralId: number,
        public personId: number,
    ) {
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/model/eligibility-summary-request.model.ts